import styled from "styled-components";
import Colors from "../../Constant/Colors";
import { STYLES } from "../../Constant/Theme";

export const Container = styled.div`
 height: 100%;
  width: ${(props) => (props.isInstructor ? "74%" : "95%")};
  ${STYLES.borderShadow};
  min-width: 240px;
  margin-top: 10px;
  background-color: white;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 10px 20px;
  overflow: hidden;
  
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  @media only screen and (max-width: 600px) {
    width:  100%;
    /* Styles for screens 600px and larger */
  }
`;